import { render } from "./AdrDatadogEvent.vue?vue&type=template&id=a8cb34e0"
import script from "./AdrDatadogEvent.vue?vue&type=script&lang=js"
export * from "./AdrDatadogEvent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__